import React from "react";
import "./searchbar.scss";

interface SearchbarProps {
  orignalItems: any[];
  setCurrentItems: any;
  placeholder?: string;
  primaryConditionKey?: string;
  secondaryConditionKey?: string;
}

const Searchbar: React.FC<SearchbarProps> = ({
  orignalItems,
  setCurrentItems,
  placeholder,
  primaryConditionKey,
  secondaryConditionKey,
}) => {
  const filterSelection = (e: string) => {
    //
    if (e !== "") {    
      const filteredItems = orignalItems.filter((item:any) => {
        return (
          ((primaryConditionKey &&
            item?.[primaryConditionKey + ""]
              ?.toLowerCase()
              ?.includes(e.toLowerCase()))) ||
          (secondaryConditionKey &&
            item?.[secondaryConditionKey + ""]
              ?.toLowerCase()
              ?.includes(e.toLowerCase()))
        );
      });
      setCurrentItems(filteredItems);
    } else {
      setCurrentItems(orignalItems);
    }
  };

  return (
    <div className="searchbarContainer">
      <input
        type="text"
        placeholder={placeholder ? placeholder : "Search"}
        onChange={(e) => {
          filterSelection(e.target.value);
        }}
      />
    </div>
  );
};

export default Searchbar;
